export default {
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '4px'
      },
      paperWidthLg: {
        maxWidth: '1280px'
      },
      paperWidthMd: {
        maxWidth: '776px'
      },
      paperWidthSm: {
        maxWidth: '480px'
      },
      paperWidthXs: {
        maxWidth: '374px'
      }
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        background: 'rgba(0, 0, 0, 0.5)'
      },
      invisible: {
        background: 'rgba(0, 0, 0, 0)'
      }
    }
  }
};
